var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 46.2231,
    stroke: "url(#paint0_linear_57_1132)",
    strokeWidth: 1.55373
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.334 31.334H62.6673M62.6673 31.334V62.6673M62.6673 31.334L31.334 62.6673",
    stroke: "url(#paint1_linear_57_1132)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_1132",
    x1: -16.5,
    y1: 36.5,
    x2: 95.5373,
    y2: -21.3836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#B2E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00305D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_1132",
    x1: 27.6327,
    y1: 31.334,
    x2: 78.6838,
    y2: 32.2873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#568EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5022A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaAbout);
export default __webpack_public_path__ + "static/media/seta_about.d4f54f8087ae295055079a69044628f8.svg";
export { ForwardRef as ReactComponent };